import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ProductModel, RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";

export function getProdcutInfosFromProductList(state: ApplicationState, id: string): SafeDictionary<ProductInfo> | undefined{
      return state.components.productInfoLists.productInfoListById[id]?.productInfoByProductId;
}